import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import { getArticleContent } from '@/hooks/useArticleContent';

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('articles.title')}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
          {t('articles.subtitle')}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => {
          const content = getArticleContent(i18n.language, article.slug);
          return (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={content.title}
                  title={`${content.title} — USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                    {content.category}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                  {content.title}
                </h3>
                <p className="mt-2 flex-1 text-sm text-foreground-600 leading-relaxed">{content.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-time-line" />
                    {t('articles.readTime', { minutes: article.readingTime })}
                  </span>
                  <span className="flex items-center gap-1 text-sm font-medium text-primary-700">
                    {t('articles.readMore')}
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}